/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetCashbackTierResponse
 */
export interface SetCashbackTierResponse {
    /**
     * 
     * @type {string}
     * @memberof SetCashbackTierResponse
     */
    userId: string;
    /**
     * The tier the user held before this call, recorded so the change is reversible from the response alone.
     * @type {number}
     * @memberof SetCashbackTierResponse
     */
    previousTier: number;
    /**
     * 
     * @type {number}
     * @memberof SetCashbackTierResponse
     */
    newTier: number;
    /**
     * The status challenge that was expired to make the grant stick, if one was active.
     * @type {number}
     * @memberof SetCashbackTierResponse
     */
    detachedChallengeId?: number | null;
}

/**
 * Check if a given object implements the SetCashbackTierResponse interface.
 */
export function instanceOfSetCashbackTierResponse(value: object): value is SetCashbackTierResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('previousTier' in value) || value['previousTier'] === undefined) return false;
    if (!('newTier' in value) || value['newTier'] === undefined) return false;
    return true;
}

export function SetCashbackTierResponseFromJSON(json: any): SetCashbackTierResponse {
    return SetCashbackTierResponseFromJSONTyped(json, false);
}

export function SetCashbackTierResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetCashbackTierResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'previousTier': json['previous_tier'],
        'newTier': json['new_tier'],
        'detachedChallengeId': json['detached_challenge_id'] == null ? undefined : json['detached_challenge_id'],
    };
}

export function SetCashbackTierResponseToJSON(json: any): SetCashbackTierResponse {
    return SetCashbackTierResponseToJSONTyped(json, false);
}

export function SetCashbackTierResponseToJSONTyped(value?: SetCashbackTierResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'previous_tier': value['previousTier'],
        'new_tier': value['newTier'],
        'detached_challenge_id': value['detachedChallengeId'],
    };
}

